import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, ReplaySubject } from 'rxjs';
import { SlapfiveActivityResponse, SlapfiveUser } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class KeplerSlapfiveService {
  private http = inject(HttpClient);

  private _user$: ReplaySubject<SlapfiveUser> = new ReplaySubject(1);

  /**
   * Return SlapFiver user account by email
   * @param email email of the user
   * @returns observable of SlapFive User
   */
  get user$(): Observable<SlapfiveUser> {
    return this._user$.asObservable();
  }

  /**
   * Add an activity and points to a SlapFiver User account by email and activity
   * @param email email of the user
   * @param firstName first name (in case the user is added)
   * @param lastName last name (in case the user is added)
   * @param company company (in case the user is added)
   * @param activity name of the activity
   * @param isTempUser is temp user with no sign in
   * @returns observable of SlapFive Activity Response
   */
  addActivity(
    email: string,
    firstName: string,
    lastName: string,
    company: string,
    activity: string,
    isTempUser?: boolean,
  ): Observable<SlapfiveActivityResponse> {
    let slapFiveUrl = `${environment.api.kepler.slapfive.url}/gc/activity`;
    if (isTempUser) {
      slapFiveUrl = `${environment.api.kepler.slapfive.url}/activity-api`;
    }

    return this.http.post<SlapfiveActivityResponse>(slapFiveUrl, {
      email: email,
      firstName: firstName,
      lastName: lastName,
      companyName: company,
      activityName: activity,
    });
  }
}
